import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import HelpAccordion from "./accordion";

type HelpAccordionsProps = {
  accordionData: { longTitle: string; en_longTitle?: string; answer: string }[];
  title: string;
};

const HelpAccordions: FC<HelpAccordionsProps> = ({ accordionData, title }) => {
  const { t } = useTranslation("needHelp");

  return (
    accordionData.length > 0 && (
      <div className="faq_section">
        <h4>{t(title)}</h4>
        {accordionData.map((tile, index) => (
          <HelpAccordion
            tile={tile}
            key={index}
            accordionHeading={t(title, { lng: "en" })}
          />
        ))}
      </div>
    )
  );
};

export default HelpAccordions;
